import { useEffect, useRef, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import { FaSearch } from "react-icons/fa"
import axios from "axios";
import { useSelector } from "react-redux";
import PaginationItem from "../components/ui/components/Pagination";
import SeoBoxItemContainer from "../components/proyectos/SeoBoxItemContainer";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import Modal from "../components/ui/Modal";
import DescriptionModal from "../components/proyectos/DescriptionModal";
import CheckBox from "../components/ui/components/CheckBox";
import ChipInfo from "../components/proyectos/ChipInfo";
import TooltipInfoQuestion from "../components/ui/components/TooltipInfoQuestion";
import SeoRowItemContainer from "../components/proyectos/SeoRowItemContainer";
import { standardServiceStatus } from "../utils/rawData/serviceStatus";
import Selector from "../components/ui/components/Selector";
import { Limits10_50 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";
import DateInput from "../components/ui/components/DateInput";
import FilterButton from "../components/ui/components/FilterButton";
import { EnfoqueWebOptions } from "../utils/rawData/enfoqueWebOptions";
import OpcionesRecompraPotencial from "../utils/plainValues/OpcionesRecompraPotencial";
import { toast } from "react-toastify";
import ClientDataModal from "../components/ui/proyectos/ClientDataModal";
import Multiselector from "../components/ui/components/Multiselector";

const ProyectosSEO = () => {

  const user = useSelector((state) => state.auth.user)

  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const isOperative = user.area.toUpperCase() !== "COMERCIAL" && user.area.toUpperCase() !== "ADMINISTRACION"
  const isCommercial = user.area.toUpperCase() === "COMERCIAL"

  const [clients, setClients] = useState([])
  const [workers, setWorkers] = useState([])
  const [areaWorkers, setAreaWorkers] = useState([])

  const [seoServices, setSeoServices] = useState([])
  const [loadingStatus, setLoadingStatus] = useState(false)

  // Por defecto aparecen los servicios mas contratados de la agencia seleccionados
  // Solo SEO Web Informativa y SEO Tienda Virtual
  const [serviceFilters, setServiceFilters] = useState(["67061b2690e8616ec15ffe87", "65778e62c1c6ac85e69c901b"])

  // Por defecto aparecen los proyectos que nos interesan
  const [statusFilters, setStatusFilters] = useState(["Por comenzar", "En proceso", "Falta pagar", "Cotizando nuevas funciones"])

  const [view, setView] = useState("Horizontal")

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)

  const [totalDocs, setTotalDocs] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [agencyWeb, setAgencyWeb] = useState(false)

  const [brandName, setBrandName] = useState("") // Búsqueda de texto de la marca

  const [responsible, setResponsible] = useState("")
  const [enfoqueWeb, setEnfoqueWeb] = useState("")
  const [recompraPotencial, setRecompraPotencial] = useState("")
  
  const getClients = async () => { // Obtener los clientes
    try {
      setLoadingStatus(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getClientsByServiceCategory?category=SEO&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      if (enfoqueWeb) {
        url += `&enfoqueWeb=${enfoqueWeb}`
      }

      if (recompraPotencial) {
        url += `&recompraPotencial=${recompraPotencial}`
      }

      if (statusFilters) {
        body.statusFilters = statusFilters
      }

      if (serviceFilters) {
        body.serviceFilters = serviceFilters
      }

      if (agencyWeb) {
        url += `&activoAgencia=${agencyWeb}`
      }

      if (startDate) {
        url += `&startDate=${new Date(startDate).toISOString()}`
      }

      if (endDate) {
        url += `&endDate=${new Date(endDate).toISOString()}`
      }

      if (responsible) {
        url += `&responsible=${responsible}`
      } 

      const response = await axios.post(url, body)

      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

      setLoadingStatus(false)

    } catch (error) {
      console.log(error)
    }
  }

  const getWorkers = async () => { // Obtener los trabajadores
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`)
      const filteredWorkers = response.data.docs.filter(worker => worker.area.toUpperCase() === "COMERCIAL" || worker.area.toUpperCase() === "ADMINISTRACION")
      const filteredAreaWorkers = response.data.docs.filter(worker => worker.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS" || worker.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS")
      setWorkers(filteredWorkers)
      setAreaWorkers(filteredAreaWorkers)
    } catch (error) {
      return false
    }
  }

  const getWebServices = async () => { // Obtener los servicios de webs
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=SEO&limit=0`)
      setSeoServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  // Modal de comentarios
  const [openModalComments, setOpenModalComments] = useState(false) // Modal comentarios
  const [openModalDescription, setOpenModalDescription] = useState(false) // Modal descripción
  const [selectedService, setSelectedService] = useState({}) // Info servicio seleccionado
  const [newComment, setNewComment] = useState("")

  useEffect(() => { // Obtenemos los clientes
    getWebServices()
    getClients()
    getWorkers()
  }, [])

  useEffect(() => { // Obtenemos los clientes cada que cambia la página y el límite
    getClients()
  }, [page, limit])

  useEffect(() => {
    getClients()
  }, [agencyWeb, startDate, endDate, enfoqueWeb, responsible, recompraPotencial])

  const didMountFiltersRef = useRef(false)
  useEffect(() => {
    if (!didMountFiltersRef.current) {
      didMountFiltersRef.current = true
      return
    }
    const timeout = setTimeout(() => {
      getClients();
    }, 3000);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, statusFilters]);

  const [dates, setDates] = useState([]);

  useEffect(() => {
    generateCalendar();
  }, [clients]);

  const generateCalendar = () => { // Genera el calendario en la parte superior con los días y los eventos
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 4); // días atrás
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 5); // días adelante

    let currentDate = new Date(startDate);
    const newDates = [];

    // Crear las fechas para el calendario (7 días atrás y 8 días adelante)
    while (currentDate <= endDate) {
      newDates.push({ date: new Date(currentDate), events: [] }); // Inicializamos las fechas sin eventos
      currentDate.setDate(currentDate.getDate() + 1); // Avanzamos un día
    }

    // Extraer y ordenar los servicios de los clientes por su fecha de finalización (endDate)
    const servicesWithDates = clients
      .map(client => {
        const firstService = client.services[0]; // Obtenemos el primer servicio
        if (firstService) {
          return firstService
        }
        return null;
      })
      .filter(service => service !== null) // Filtramos los clientes que no tienen servicios
      .sort((a, b) => a.eventDate - b.eventDate); // Ordenamos los servicios por fecha de finalización (endDate)

    // Asignamos los eventos a las fechas correspondientes
    servicesWithDates.forEach(service => {
      // Comparamos las fechas ignorando la parte de la hora
      const eventIndex = newDates.findIndex(dateObj => {
        return dateObj.date.toISOString().split('T')[0] === service.fechaFin.split('T')[0]; // Compara solo la fecha (YYYY-MM-DD)
      });
    
      if (eventIndex !== -1) {
        newDates[eventIndex].events.push(service); // Añadimos el evento a la fecha correspondiente
      }
    });

    // Ordenamos las fechas por su valor (aunque ya deberían estar ordenadas)
    newDates.sort((a, b) => a.date - b.date);
    // Actualizamos el estado con las fechas y eventos asignados
    setDates(newDates);
  };

  const [highlightedRow, setHighlightedRow] = useState(null); // Estado para manejar la fila resaltada
  const serviceRefs = useRef([]); // Usamos un array para almacenar las referencias a las filas de los servicios

  // Permisos
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    isAssistant: false,
    isBossArea: false,
    isUserArea: false,
  });

  const definePermissions = (user) => {
    const updatedPermissions = {
      isAdmin: user.area.toUpperCase() === "ADMINISTRACION",
      isAssistant: user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() === "ASISTENTE",
      isUserArea: user.area.toUpperCase() === "SOFTWARE" && user.subarea.toUpperCase() === "CMS",
      isBossArea: user.area.toUpperCase() === "MARKETING" && (user.puesto.toUpperCase() === "JEFE DE GOOGLE" || user.puesto.toUpperCase() === "JEFE EN META")
    };
    setPermissions(updatedPermissions);
  };
  
  useEffect(() => {
    if (user) definePermissions(user);
  }, [user]);

  //Descripcion
  const parseDescription = (description) => { // Parsear la info
    if (!description || typeof description !== "string") {
      return [];
    }
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = selectedService?.customDescriptionActive
  ? selectedService?.customDescriptionText
  : selectedService?.servicio?.preciosUnitarios.find(
      (precioUnit) => precioUnit?.plan.id === selectedService?.planServicio?.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText)

  // Gestión de columnas activas y permisos

  const conditions = {
    isAdmin: isAdmin,
    isOperative: isOperative, 
    isCommercial: isCommercial
  }

  // Estado para controlar la visibilida ddel modal
  const [showColFiltersModal, setShowColFiltersModal] = useState(false);

  // Definir combos para el rapido seleciconado de opciones
  const combos = [
    // { id: 1, name: "Administratico", cols: [1, 2, 4, 5, 6, 7, 8, 13, 15, 16, 17, 19, 20, 21, 24, 25, 26, 27, 28, 29, 30, 31] },
    // { id: 2, name: "Proyecto", cols: [1, 2, 4, 5, 6, 7, 8, 13, 17, 18, 21, 25, 33, 34, 36, 37, 38] },
    // { id: 3, name: "Horizontal", cols: [1, 2, 4, 5, 6, 7, 8, 13, 14, 21, 22, 23, 24, 32] },
    // { id: 5, name: "Todas", cols: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38] }
  ];

  //Columnas activas, con restricciones por áreas
  const cols = [
    { first: true, sticky: true, name: "Coti", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { second: true, name: "Cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Ir al proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "VIP", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link Drive", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Datos cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link oficial web", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Regalo(?)", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Enfoque web", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Recompra potencial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Moroso", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "ID Cotización", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Estado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente" },
    { name: "Formulario", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Descripción servicio", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Comentarios operativa", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Plan", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Nro encargado", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Tipo cliente", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Especialista" },
    { name: "Responsable", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "CheckList", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", },
    { name: "Fecha venta o ingreso", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true}, chipContent: "Sistema", description: "Fecha cuando el cliente hace el primer pago" },
    { name: "Fecha inicio proyecto", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Sistema", description: "Fecha en cuando el especialista tiene la primera reunion en el sistema según la primera reunión, sin embargo es modificable por el especialista" },
    { name: "Fecha fin contrato", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false}, chipContent: "Admin" },
    { name: "Duración del proyecto establecido", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, descripcion: "Tiempo en dias respecto a la duracion total del proyecto establecida por administración" },
    { name: "Días para la finalización", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Precio venta", show: true, conditions: {"isAdmin": true, "isOperative": false, "isCommercial": true} },
    { name: "Vendedor", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link recursos", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": false} },
    { name: "Control de calidad", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true}, chipContent: "Asistente" },
    { name: "Link investigación", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link reporte inicial", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
    { name: "Link reporte final", show: true, conditions: {"isAdmin": true, "isOperative": true, "isCommercial": true} },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }));

  // Función helper para evaluar si una columna debe mostrarse
  const shouldShowColumn = (col) => {
    // Check if column is enabled in colFilters
    if (!colFilters[col.id]) return false;
    // Check conditions
    if (!col.conditions) return true;
    return Object.keys(col.conditions).some(role => conditions[role] && col.conditions[role]);
  };

  const userHasAccess = (col) => {
    if (isAdmin && col.conditions.isAdmin) return true;
    if (isOperative && col.conditions.isOperative) return true;
    if (isCommercial && col.conditions.isCommercial) return true;
    return false;
  };

  const [colFilters, setColFilters] = useState(() => {
    const initialFilters = {};
    colsWithIds.forEach(col => {
      initialFilters[col.id] = col.show;
    });
    return initialFilters;
  });

  // Cálculo dinámico de offsets para columnas sticky
  const stickyOffsets = (() => {
    const defs = [
      { key: 'first', width: 3.5 },
      { key: 'second', width: 11 },
    ];
    const offsets = {};
    let cumulative = 0;
    for (const def of defs) {
      offsets[def.key] = `${cumulative}rem`;
      const stickyCol = colsWithIds.find(c => c[def.key]);
      if (stickyCol && shouldShowColumn(stickyCol)) {
        cumulative += def.width;
      }
    }
    return offsets;
  })();

  const handleAddComment = async () => { // Agregar comentario en modal de comentarios del proyecto
    if (!newComment.trim()) {
      toast.error("Por favor, ingresa un comentario antes de enviar.");
      return;
    }

    const nuevoComentario = {
      usuario: user.id,
      comentario: newComment,
      fecha: new Date().toISOString(),
    };

    const comentariosOperativa = selectedService?.comentariosOperativa || [];

    const updatedComentariosOperativa = [
      ...comentariosOperativa.map((comentario) => ({
        ...comentario,
        usuario: typeof comentario.usuario === "object" ? comentario.usuario.id : comentario.usuario,
      })),
      nuevoComentario,
    ];

    const updatedServiceData = {
      ...selectedService,
      comentariosOperativa: updatedComentariosOperativa,
    };

    // Actualiza el servicio seleccionado localmente para reflejar el nuevo comentario
    setSelectedService(updatedServiceData);

    // Actualiza el estado de clients para que el cambio sea visible en la tabla
    setClients((prevClients) =>
      prevClients.map((client) => {
        if (client.id !== selectedService?.cotizacion?.cliente?.id) return client;
        console.log("Paso 1")
        return {
          ...client,
          services: client.services.map((srv) =>
            srv.id === selectedService.id
              ? { ...srv, comentariosOperativa: updatedComentariosOperativa }
              : srv
          ),
        };
      })
    );

    try {
      await axios.put(
        `${BACKEND}/api/serviciosCotizaciones/${updatedServiceData.id}`,
        { comentariosOperativa: updatedComentariosOperativa }
      );
      toast.success("Comentario agregado con éxito");
      setNewComment("");
    } catch (error) {
      console.log(error);
      toast.error("Error al agregar el comentario");
    }
  };

  // Datos del cliente 
  const [openModalClientData, setOpenModalClientData] = useState(false) // estado modal
  const [selectedClientData, setSelectedClientData] = useState(null) // cliente seleccionado

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal de comentarios del proyecto
        activeModal={openModalComments}
        onClose={() => {setOpenModalComments(false); setSelectedService({})}}
        title="Comentarios proyecto"
        className="max-w-3xl"
        centered
      >
        <div className="flex flex-col gap-2">

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Cliente: </span>
            <span className="font-light">{selectedService?.cotizacion?.cliente?.nombreComercial}</span>
          </div>

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Servicio: </span>
            <span className="font-light">{selectedService?.servicio?.name}</span>
          </div>

          <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
          {/* Sección de comentarios */}
          <div className="max-h-[600px] overflow-y-auto">
            {selectedService?.comentariosOperativa?.map((comment, index) => (
              <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

                <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                  <div className="flex flex-row gap-2 items-center justify-center">
                    <img
                      src={comment?.usuario?.foto?.url || user?.foto?.url}
                      alt={comment?.usuario?.nombre || user?.nombre}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name} - <span className="text-xs font-light text-gray-600 lowercase">{comment?.usuario.puesto || user.puesto}</span></span>
                  </div>
                  <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
                </div>

                <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
              </div>
            ))}
          </div>

          {/* Sección para agregar un nuevo comentario */}
          <div className="mt-3">
            <h3 className="text-xs font-bold text-gray-700">Añadir comentario:</h3>
            <textarea
              className="w-full p-3 mt-2 border text-xs border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="2"
              placeholder="Escribe tu comentario aquí..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <button
              onClick={handleAddComment}
              className="mt-3 px-4 py-2 bg-blue-600 text-xs text-white rounded-md hover:bg-blue-700 focus:outline-none"
            >
              Agregar Comentario
            </button>
          </div>
        </div>
      </Modal>

      <Modal // Modal de filtros de columnas
        activeModal={showColFiltersModal}
        onClose={() => {setShowColFiltersModal(false)}}
        title="Filtros de columnas"
        className="max-w-6xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-row gap-2 items-center justify-start">
            {combos.map((combo) => (
              <button 
                key={combo.id} 
                className="flex flex-row items-center justify-start gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors duration-200"
                onClick={() => {
                  // Create new filters object with all columns initially false
                  const newColFilters = {};
                  
                  // Set all columns to false first
                  colsWithIds.forEach(col => {
                    newColFilters[col.id] = false;
                  });
                  
                  // Then set only the combo columns to true
                  combo.cols.forEach(colId => {
                    newColFilters[colId] = true;
                  });
                  
                  setColFilters(newColFilters);
                }}
              >
                <span className="text-xs font-semibold text-gray-700">{combo.name}</span>
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2 items-center justify-between">
            {colsWithIds
              .filter(col => userHasAccess(col))
              .map((col) => (
                <div key={col.id} className="flex flex-row items-center justify-start gap-2">
                  <CheckBox
                    checked={colFilters[col.id] || false}
                    onChange={(e) => {
                      setColFilters((prev) => ({
                        ...prev,
                        [col.id]: e.target.checked
                      }));
                    }}
                  />
                  <span className="text-xs font-semibold text-gray-700">{col.name}</span>
                </div>
              ))
            }
          </div>
        </div>

      </Modal>

      <DescriptionModal
        openModalDescription = {openModalDescription}
        brandName = {selectedService?.cotizacion?.cliente?.nombreComercial}
        serviceName = {selectedService?.servicio?.name}
        parsedDescription = {parsedDescription}
        setOpenModalDescription = {setOpenModalDescription}
        setSelectedService = {setSelectedService}
      />

      <ClientDataModal
        openModalClientData={openModalClientData}
        setOpenModalClientData={setOpenModalClientData}
        selectedClientData={selectedClientData}
        setSelectedClientData={setSelectedClientData}
        setClients={setClients}
      />

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaSearch className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Proyectos SEO</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            {(isAdmin || isOperative) && (
              <Selector
                title="Vista"
                value={view}
                setter={setView}
                width="w-[8rem]"
                options={[{label: "Vertical", value: "Vertical"}, {label: "Horizontal", value: "Horizontal"}]}
                disabled={loadingStatus}
              />
            )}
           
           <Selector
              title="Límite"
              value={limit}
              setter={setLimit}
              options={Limits10_50}
              width="w-[5rem]"
              disabled={loadingStatus}
            />

            <SearchBar
              value={brandName}
              setter={setBrandName}
              pageSetter={setPage}
              getter={getClients}
              placeholder="Buscar marca..."
              text="Buscar"
              disabled={loadingStatus}
            />

          </div>

        </div>
      </div>

      {/* Filtros de fechas */}       
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-0.5 gap-8">
        <div className="flex flex-row w-full items-center gap-4 justify-center overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <DateInput
            title="Fecha inicio"
            value={startDate}
            setter={setStartDate}
            disabled={loadingStatus}
          /> 

          <DateInput
            title="Fecha fin"
            value={endDate}
            setter={setEndDate}
            disabled={loadingStatus}
          />

          <Selector
            title="Responsable"
            value={responsible}
            setter={setResponsible}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{value: "", label: "Todos"}, ...areaWorkers.map((worker) => ({label: worker.name, value: worker.id}))]}
          />

          <Selector
            title="Enfoque web"
            value={enfoqueWeb}
            setter={setEnfoqueWeb}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={EnfoqueWebOptions}
          />

          <Selector
            title="Recompra potencial"
            value={recompraPotencial}
            setter={setRecompraPotencial}
            disabled={loadingStatus}
            width="w-[8rem]"
            options={[{label: "Todos", value: ""}, ...OpcionesRecompraPotencial]}
          />
          
          <CheckBox
            checked={agencyWeb}
            onChange={(e) => setAgencyWeb(e.target.checked)}
            disabled={loadingStatus}
            text="Activos Agencia"
          />

          {/* Columnas activas */}
          {view === "Horizontal" && (
            <FilterButton action={() => setShowColFiltersModal(true)} content="Filtros de columnas" />
          )}
        </div>
      </div>

      {/* UI/UX & SEO services and status */}
      <div className="flex flex-row bg-gray-100 mt-0.5 mb-0.5 pt-1 pb-2 px-4">
        <div className="flex flex-row w-full items-center pt-1 justify-center gap-4 overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <Multiselector 
            title="Servicios"
            value={serviceFilters}
            handlerChange={(vals) => setServiceFilters(vals)}
            options={seoServices}
            disabled={loadingStatus}
            formControlHeight={32}
            formControlWidth="10vw"
            menuItemWitdh={270}
            itemHeight={48}
            menuItemHeight="30px"
            itemWidth="40vw"
          />
          <Multiselector 
            title="Estado"
            value={statusFilters}
            handlerChange={(vals) => setStatusFilters(vals)}
            options={standardServiceStatus}
            disabled={loadingStatus}
            formControlHeight={32}
            formControlWidth="10vw"
            menuItemWitdh={200}
            itemHeight={48}
            menuItemHeight="30px"
            itemWidth="40vw"
          />
        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
          ) : (
            clients.length === 0 ? (
              <NoDataScreen />
            ) : (
              view === "Vertical" ? (
                <table className="w-full table-fixed">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-[10px] font-semibold">

                      <td className="w-[15%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div>
                          Cliente
                        </div>
                      </td>
                      {seoServices
                        .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                        .map((service) => (
                          <td
                            key={service.id}
                            className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red"
                          >
                            <div>{service.name}</div>
                          </td>
                        ))
                      }

                    </tr>
                  </thead>

                  <tbody>
                    {clients.map((client, rowIndex) => (
                    <tr
                      key={client.id}
                      ref={(el) => (serviceRefs.current[clients.indexOf(client)] = el)} // Asignamos la referencia a cada fila
                      className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 
                        ${highlightedRow === rowIndex ? 'bg-orange-100' : ''} // Resaltar la fila si coincide con la fila seleccionada
                      `}
                    >
                        <td 
                          scope="row" 
                          className="max-w-[20px] px-4 py-2 max-w-xs font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100"
                        >
                          <a 
                            href={`/home/seguimiento/${client.id}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            {client.nombreComercial}
                          </a>
                        </td>

                        {seoServices
                          .filter((service) => serviceFilters.length === 0 || serviceFilters.includes(service.id))
                          .map((service) => (
                            <SeoBoxItemContainer 
                              key={service.id} 
                              service={service} 
                              client={client}
                              user={user}
                              permissions={permissions}
                              allServiciosList={seoServices}
                              workers={workers}
                            />
                          ))
                        }

                      </tr>
                    ))}

                  </tbody>
                </table>  
              ) : (
                <table className="w-full text-xs">
                  <thead className="sticky top-0 bg-gray-200 z-50">
                    <tr className="text-gray-700 text-center text-[10px] font-bold z-50">
                      {colsWithIds
                        .filter(col => shouldShowColumn(col))
                        .map(col => (
                          <th key={col.id} className={`${col.first || col.second ? "sticky" : ""} z-20 px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50`} style={{ left: stickyOffsets[col.first ? 'first' : col.second ? 'second' : ''] }}>
                            <div className="flex flex-col items-center justify-center gap-1">
                              {col.name}
                              {col.chipContent ? <span className="text-black">{ChipInfo(col.chipContent)}</span> : null}
                              {col.description ? <TooltipInfoQuestion content={col.description} /> : null}
                            </div>
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {clients.map((c) => c.services.map((s, i) => {
                      return (
                        <SeoRowItemContainer
                          key={i}
                          sticky={[1, 2]}
                          serviceData={s}
                          c={c}
                          activeCols={colsWithIds}
                          shouldShowColumn={shouldShowColumn}
                          setClients={setClients}
                          user={user}
                          permissions={permissions}
                          setOpenModalDescription={setOpenModalDescription}
                          setSelectedService={setSelectedService}
                          setOpenModalComments={setOpenModalComments}
                          seoServices={seoServices}
                          setOpenModalClientData={setOpenModalClientData}
                          setSelectedClientData={setSelectedClientData}
                          stickyOffsets={stickyOffsets}
                        />
                      )
                    }))}
                  </tbody>
                </table> 
              )
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem 
        actualDocs={clients.length}
        totalDocs={totalDocs}
        entity={"clientes"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>    
  )
}

export default ProyectosSEO